import React from 'react'
import css from '../../style.module.scss'
import cn from 'classnames'
import {
  InputText,
  Button,
  Radio
} from 'components/ui'
// import { IconPlus } from 'components/icons'
import { orderFieldNames, deliveryTypes } from '../../../../constants'
import { FormikProvider, /* FieldArray */ } from 'formik'
import PropTypes from 'prop-types'
// import { pathOr } from 'ramda'

OrderForYourself.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
}

export default function OrderForYourself ({
  onClickPreviousButton,
  handleChange,
  handleSubmit,
  values,
  cityName,
  cityHasDelivery,
  formikBag,
  // onToggleFamily,
  // hasFamily,
  errors,
  touched,
  // onClickAddFamilyMember,
  serverError,
}) {
  return (
    <div className={css.orderForYourself}>
      <button
          className="linkBack label-2 primary-color a"
          onClick={onClickPreviousButton}>
        Назад
      </button>
    
      <div className={css.toWhom}>
        <p className={cn("label-2", "dark-grey", css.label)}>Я заказываю набор:</p>
        <div className={css.prevValues}>
          <p className="body-text black">Для себя в г. {cityName}</p>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <FormikProvider value={formikBag}>
          <div className={css.deliveryType}>

            <p className={cn("label-2", "dark-grey", css.label)}>Тип доставки</p>
            <div className="flex mobile-column">
              <div className={css.radioButtons}>
                <Radio
                  id="delivery_courier"
                  text="Курьерская доставка"
                  name={orderFieldNames.DELIVERY}
                  value={deliveryTypes.COURIER}
                  onChange={handleChange}
                  defaultChecked={
                    values[orderFieldNames.DELIVERY] === deliveryTypes.COURIER
                  }
                  disabled={!cityHasDelivery}
                />
              </div>
              <div className={css.radioButtons}>
                <Radio
                  id="delivery_pickup"
                  text="Самовывоз"
                  name={orderFieldNames.DELIVERY}
                  value={deliveryTypes.PICKUP}
                  onChange={handleChange}
                  defaultChecked={
                    values[orderFieldNames.DELIVERY] === deliveryTypes.PICKUP
                  }
                />
              </div>
            </div>

            {/* блок, активный если выбрана курьерская доставка */}
            {(values[orderFieldNames.DELIVERY] === deliveryTypes.COURIER) &&
              <div className={css.courierInfo}>
                <InputText
                  placeholder="Адрес доставки"
                  name={orderFieldNames.ADDRESS}
                  value={values[orderFieldNames.ADDRESS]}
                  onChange={handleChange}
                  error={touched[orderFieldNames.ADDRESS] && errors[orderFieldNames.ADDRESS]}
                />
              </div>
            }

            {/* блок, активный если выбран самовывоз */}
            {(values[orderFieldNames.DELIVERY] === deliveryTypes.PICKUP) &&
              <div className={css.pickUpInfo}>
                <p className="body-text grey">
                  Наш менеджер свяжется с вами, чтобы договориться об удобном месте и времени доставки
                </p>
              </div>
            }

          </div>

          {/* <FieldArray
            name={orderFieldNames.FAMILY}
            render={arrayHelpers => (<React.Fragment>
              <div className={css.personsNumber}>
                <p className={cn("label-2", "dark-grey", css.label)}>Количество членов семьи</p>
                <div className="flex mobile-column">
                  <div className={css.radioButtons}>
                    <Radio
                      id="single"
                      text="Только я"
                      name="has-family"
                      onChange={onToggleFamily}
                      defaultChecked
                    />
                  </div>
                  <div className={css.radioButtons}>
                    <Radio
                      id="more"
                      text="Добавить членов семьи"
                      name="has-family"
                      onChange={onToggleFamily}
                    />
                  </div>
                </div>

                {hasFamily && values[orderFieldNames.FAMILY].map((familyMember, index) => (
                  <div className={css.familyInfo} key={`family-member-key-${index}`}>
                    <div className={cn("form-layout", css.familyMember)}>

                      <div className={css.familyMemberCounter}>
                        <div className={css.counterLine}></div>
                          <p className="label-2">Родственник {index + 1}</p>
                        <div className={css.counterLine}></div>
                      </div>

                      <div className="form-field">
                        <InputText
                          name={`${orderFieldNames.FAMILY}.${index}.${orderFieldNames.FAMILY_LASTNAME}`}
                          placeholder="Фамилия"
                          onChange={handleChange}
                          value={values
                            [orderFieldNames.FAMILY]
                            [index]
                            [orderFieldNames.FAMILY_LASTNAME]
                          }
                          error={
                            pathOr(
                              false,
                              [orderFieldNames.FAMILY, 0, orderFieldNames.FAMILY_LASTNAME],
                              touched
                            ) && pathOr(
                              '',
                              [orderFieldNames.FAMILY, index, orderFieldNames.FAMILY_LASTNAME],
                              errors
                            )
                          }
                        />
                      </div>
                      <div className="form-field">
                        <InputText
                          placeholder="Имя"
                          name={`${orderFieldNames.FAMILY}.${index}.${orderFieldNames.FAMILY_NAME}`}
                          onChange={handleChange}
                          value={values
                            [orderFieldNames.FAMILY]
                            [index]
                            [orderFieldNames.FAMILY_NAME]
                          }
                          error={pathOr(
                            false,
                            [orderFieldNames.FAMILY, 0, orderFieldNames.FAMILY_NAME],
                            touched
                          ) && pathOr(
                            '',
                            [orderFieldNames.FAMILY, index, orderFieldNames.FAMILY_NAME],
                            errors
                          )}

                        />
                      </div>
                      <div className="form-field">
                        <InputText
                          placeholder="Отчество"
                          name={`${orderFieldNames.FAMILY}.${index}.${orderFieldNames.FAMILY_PATRONYMIC}`}
                          onChange={handleChange}
                          value={values
                            [orderFieldNames.FAMILY]
                            [index]
                            [orderFieldNames.FAMILY_PATRONYMIC]
                          }
                          error={pathOr(
                            false,
                            [orderFieldNames.FAMILY, 0, orderFieldNames.FAMILY_PATRONYMIC],
                            touched
                          ) && pathOr(
                            '',
                            [orderFieldNames.FAMILY, index, orderFieldNames.FAMILY_PATRONYMIC],
                            errors
                          )}
                        />
                      </div>
                      <div className="form-field">
                        <InputText
                          placeholder="Кем приходится"
                          name={`${orderFieldNames.FAMILY}.${index}.${orderFieldNames.FAMILY_KINSHIP}`}
                          onChange={handleChange}
                          value={values
                            [orderFieldNames.FAMILY]
                            [index]
                            [orderFieldNames.FAMILY_KINSHIP]
                          }
                          error={pathOr(
                            false,
                            [orderFieldNames.FAMILY, 0, orderFieldNames.FAMILY_KINSHIP],
                            touched
                          ) && pathOr(
                            '',
                            [orderFieldNames.FAMILY, index, orderFieldNames.FAMILY_KINSHIP],
                            errors
                          )}
                        />
                      </div>
                      <div className="form-field">
                        <InputText
                          placeholder="E-mail или Номер телефона"
                          name={`${orderFieldNames.FAMILY}.${index}.${orderFieldNames.FAMILY_CONTACT}`}
                          onChange={handleChange}
                          value={values
                            [orderFieldNames.FAMILY]
                            [index]
                            [orderFieldNames.FAMILY_CONTACT]
                          }
                          error={pathOr(
                            false,
                            [orderFieldNames.FAMILY, 0, orderFieldNames.FAMILY_CONTACT],
                            touched
                          ) && pathOr(
                            '',
                            [orderFieldNames.FAMILY, index, orderFieldNames.FAMILY_CONTACT],
                            errors
                          )}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {hasFamily && !errors.length &&
                <div className={css.addFamilyMemberWrap}>
                  <button
                    className={cn(css.addFamilyMember, 'pure')}
                    onClick={onClickAddFamilyMember(arrayHelpers)}
                  >
                    <div className={css.primaryColor}>
                      <IconPlus />
                    </div>
                    <p className="label-2">
                      Добавить еще родственника
                    </p>
                  </button>
                </div>
              }
            </React.Fragment>)}
          /> */}


          <div className={css.buttonWrap}>
            {
              serverError && 
                <React.Fragment>
                  <p className="caption red">{serverError}</p>
                  <p><br /></p>
                </React.Fragment>
            }
            <Button blue className="form-button" text={'Заказать'} type="submit"/>
          </div>
        </FormikProvider>
      </form>


    </div>
  )
}
